import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { DayOfWeek } from 'api/ordering-service/ordering-service.types';
import { DateTime } from 'luxon';
import { createContext, ReactNode } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import { AnyObjectSchema } from 'yup';
import { schedulerToolbarFormSchema } from './scheduler-toolbar-form/scheduler-toolbar-form.schema';

export type AdditionalData = {
  additionalDataField: ReactNode;
  additionalDataSchema: AnyObjectSchema;
  additionalDataRenderer: (params: GridRenderCellParams) => ReactNode;
  additionalDataColumnLabel: string;
};

export type DaysOfWeek = {
  id: string;
  label: string;
};

export type SchedulePayload = {
  daysOfWeek: DaysOfWeek[];
  timeRange: [DateTime, DateTime];
  additionalData: any;
};

export type Schedule<AdditionalDataType = any> = {
  day: DayOfWeek;
  startTime: string;
  endTime: string;
  additionalData?: AdditionalDataType;
};

export type SchedulerContextType = {
  schedules: Schedule[];
  addSchedule: (schedule: SchedulePayload) => void;
  removeSchedule: (scheduleToRemove: Schedule) => void;
  timeFormat?: string;
  compact?: boolean;
  additionalData?: AdditionalData;
  fieldState: ControllerFieldState;
  schema?: typeof schedulerToolbarFormSchema;
};

export const SchedulerContext = createContext<SchedulerContextType>(undefined);
